import { BaseDetail } from 'App/Component/Bases'
import fields from './fields'

class PageAdd extends BaseDetail {
  title = 'Keyword Page'
  urlData = 'module-expertSystem-keywordPage'
  fields = fields
  state = {
    isCheckingPermission: false,
    isAccessAllowed: true
  }
}

export default PageAdd